var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDealsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.474 14.51h-3.685V7.708c0-.25-.235-.453-.526-.453h-2.631V4.08c0-.25-.236-.454-.527-.454h-1.579V.453C10.526.203 10.291 0 10 0c-.29 0-.526.203-.526.453v3.174h-1.58c-.29 0-.526.204-.526.454v3.174H4.737c-.29 0-.526.203-.526.453v5.895H.526c-.29 0-.526.203-.526.453v8.162c0 .25.236.453.526.453h18.948c.29 0 .526-.202.526-.453v-7.255c0-.25-.235-.453-.526-.453zM8.42 4.534h3.158v2.72H8.42v-2.72zM1.053 14.51H4.21v7.255H1.053V14.51zm4.21-6.348h9.474v13.603H5.263V8.162zm13.684 13.603H15.79v-6.348h3.158v6.348z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.895 10.429v9.068h1.052V10.43zm3.158 0v9.068h1.052V10.43z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealsIcon);
export default __webpack_public_path__ + "static/media/deals-icon.4f3575540809bd60b483ef1e16fba4a6.svg";
export { ForwardRef as ReactComponent };